export const ROLE_COLORS = { super_admin: '#DC2626', admin: '#D97706', recruiter: '#0076A3', candidate: '#059669' };
export const CHART_TOOLTIP_STYLE = { background: '#fff', border: '1px solid #ECE7DE', borderRadius: 10 };
